module.exports = __webpack_public_path__ + "img/page3-3.313d751a.png";